<template>
  <div class="table_wrap">
    <el-table :data="utilityData" class="list-table"
              header-cell-class-name="list-header">
      <el-table-column label="이벤트" class-name="text-center">
        <template v-slot="{ row }">
          {{ returnType(row.udl_type) }}
        </template>
      </el-table-column>
      <el-table-column label="가격" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.udl_price }}Mg
        </template>
      </el-table-column>
      <el-table-column label="판매자" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.m_seller_nick }}
        </template>
      </el-table-column>
      <el-table-column label="구매자" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.m_buyer_nick }}
        </template>
      </el-table-column>
      <el-table-column label="날짜" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.created_at }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins"

export default {
  name: "UtilityListTransactionLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {};
  },
  props: {
    utilityData: {
      default: () => {
        return [];
      },
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      },
    },
  },
  data() {
    return {};
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    returnType(type) {
      if (type == 0) {
        return '구매'
      } else if (type == 1) {
        return '선물하기'
      } else {
        return '';
      }
    }
  },
  watch: {},
};
</script>

<style scoped></style>
